import React from 'react';
import './OurPractices.css';

const OurPractices = () => {
  const practices = [
    {
      title: 'PRODUCT CERTIFICATION',
      description: 'Ensuring your products meet industry-specific standards for safety, quality, and performance.'
    },
    {
      title: 'CE CERTIFICATION',
      description: 'Confirming that your products comply with EU safety, health, and environmental protection requirements.'
    },
    {
      title: 'FSSC 22000 CERTIFICATION',
      description: 'Providing a comprehensive certification scheme for food safety management systems, ensuring food safety and quality.'
    },
    {
      title: 'KOSHER CERTIFICATE',
      description: 'Verifying that your products adhere to strict kosher dietary laws and standards.'
    }
  ];

  return (
    <section className="our-practices">
      <div className="practices-container">
        <div className="practices-header">
          <div className="practices-gold-line"></div>
          <h2 className="practices-title">Our Practices</h2>
          <p className="practices-subtitle">
            Our certifications cover safety, quality, and compliance standards for your products.
          </p>
        </div>
        
        <div className="practices-grid">
          {practices.map((practice, index) => (
            <div key={index} className="practice-card">
              <h3 className="practice-card-title">{practice.title}</h3>
              <p className="practice-card-description">{practice.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPractices;

